import { graphql } from "gatsby";

import { isBrowser } from "../utils/index";
import { getCurrencyCode, getPrice, getProductId } from "../utils/shopify";

const name = "viewProduct";

export type ViewProductEvent = {
  id: string;
  name: string;
  type: "product_group";
  category: string;
  value: number;
  currency: string;
  // Shopify Analytics fields
  productGid: string;
  variantGid: string;
  variantName: string;
  brand: string;
  sku: string | null;
};

const viewProduct = (result: Queries.ViewProductEventFragment) => {
  if (!isBrowser || !result.shopify) return;

  const { shopify } = result;
  const variant = shopify.variants?.[0];

  const event = new CustomEvent<ViewProductEvent>(name, {
    detail: {
      id: getProductId(shopify),
      name: shopify.title,
      type: "product_group",
      category: shopify.productType,
      value: getPrice(shopify),
      currency: getCurrencyCode(shopify),
      // Shopify Analytics fields
      productGid: shopify.shopifyId,
      variantGid: variant?.shopifyId ?? "",
      variantName: variant?.title ?? "",
      brand: shopify.vendor,
      sku: variant?.sku ?? null,
    },
  });

  console.info(`🎯 → %c${event.type}`, "font-style: italic", event.detail);

  window.dispatchEvent(event);
};

export const register = (fn: (e: CustomEvent<ViewProductEvent>) => void) => {
  window.addEventListener(name, fn as EventListener, { passive: true });
  return () => window.removeEventListener(name, fn as EventListener);
};

export const query = graphql`
  fragment ViewProductEvent on PrismicProduct {
    shopify {
      title
      productType
      vendor
      ...ShopifyId
      ...ShopifyPrice
      ...ShopifyCurrency
      variants {
        shopifyId
        title
        sku
      }
    }
  }
`;
export default viewProduct;
